<template>
  <div class="price-display">
    <ykc-form ref="fromRules">
      <ykc-form-item
        :required="true"
        :label="'价格类别'"
        :class="feeList.length == 1 ? 'box-bottom' : ''">
        <div class="configCategory" v-for="(item, index) in dynamicFeeList" :key="index">
          <!-- <ykc-icon name="reduce" :class="{ disabled: false }"></ykc-icon> -->
          <ykc-input
            class="configCategory-input"
            v-model="item.name"
            :maxlength="5"
            :disabled="true"
            :placeholder="'请输入类别名称'"
            :class="{ error: item.errorName }"
            @blur="verifyfeeTypes(1, index, item)">
            <template slot="prepend">类别名称</template>
          </ykc-input>
          <ykc-input
            class="box-width box-width-right"
            v-model="item.powerRate"
            :maxlength="6"
            :disabled="true"
            :placeholder="'请输入电费单价'"
            :class="{ error: item.errorPrice }"
            @blur="verifyfeeTypes(2, index, item)">
            <template slot="prepend">电费</template>
            <template slot="append">元/度</template>
          </ykc-input>
          <ykc-input
            class="box-width"
            v-model="item.serviceRate"
            :maxlength="6"
            :disabled="true"
            :class="{ error: item.errorServicePrice }"
            @blur="verifyfeeTypes(3, index, item)">
            <template slot="prepend">服务费</template>
            <template slot="append">元/度</template>
          </ykc-input>
          <ykc-input
            class="box-width"
            v-model="item.activityServiceRate"
            :maxlength="6"
            :disabled="true"
            :class="{ error: item.errorServicePrice }"
            @blur="verifyfeeTypes(3, index, item)">
            <template slot="prepend">平台活动服务费</template>
            <template slot="append">元/度</template>
          </ykc-input>
          <ykc-input
            class="box-width"
            v-model="item.vipServiceRate"
            :maxlength="6"
            :hidden="isVipServiceRateHidden"
            :disabled="priceDisabled"
            :class="{ error: item.errorVipServicePrice }"
            @blur="verifyfeeTypes(3, index, item)">
            <template slot="prepend">会员卡服务费</template>
            <template slot="append">元/度</template>
          </ykc-input>
          <div
            class="rules-error weight-syl el-form-item__error"
            v-if="
              item.errorName ||
              item.errorPrice ||
              item.errorServicePrice ||
              item.errorVipServicePrice
            ">
            {{
              item.errorName ||
              item.errorPrice ||
              item.errorServicePrice ||
              item.errorVipServicePrice
            }}
          </div>
        </div>
      </ykc-form-item>
      <ykc-form-item :required="true" :label="'价格展示'" v-show="feeList.length > 1">
        <div class="configCategory" v-for="(item, index) in timeList" :key="index">
          <ykc-dropdown
            class="time-dropdown"
            v-model="item.startValue"
            :data="startTimeList"
            :configSet="configSet"
            :disabled="true"
            :class="{ error: item.errorStart }"
            @focus="selectFocusTime(1, index, item)"
            @change="selectChange($event, 1)"></ykc-dropdown>
          <div class="time-line color-grey">至</div>
          <ykc-dropdown
            class="time-dropdown"
            v-model="item.endValue"
            :data="endTimeList"
            :configSet="configSet"
            :disabled="true"
            :placeholder="'请选择结束时间'"
            :class="{ error: item.errorEnd }"
            @focus="selectFocusTime(2, index, item)"
            @change="selectChange($event, 2)"></ykc-dropdown>
          <ykc-dropdown
            class="feeType-dropdown"
            v-model="item.feeTypeName"
            :data="dynamicFeeList"
            :configSet="configSet"
            :disabled="true"
            :placeholder="'请选择价格类别'"
            :class="{ error: item.errorName }"
            @change="selectChange($event, 3)"></ykc-dropdown>
          <div
            v-if="(item.errorStart || item.errorEnd || item.errorName) && feeList.length > 1"
            class="rules-error weight-syl el-form-item__error">
            {{ item.errorStart || item.errorEnd || item.errorName }}
          </div>
        </div>
        <div class="configCategory" v-show="isAddTime !== 2">
          <ykc-input
            class="time-width"
            :disabled="true"
            :placeholder="'剩余时段价格统一选择'"></ykc-input>
          <ykc-dropdown
            class="box-width box-width-left"
            :data="dynamicFeeList"
            v-model="otherTime"
            :configSet="configSet"
            :disabled="true"
            :placeholder="'请选择价格类别'"
            @change="selectChange($event, 4)"></ykc-dropdown>
        </div>
      </ykc-form-item>
    </ykc-form>
  </div>
</template>

<script>
  import { toFixed } from '@/utils';

  export default {
    name: 'price-display',
    props: {
      priceData: null, // 价格数据
      priceDisabled: {
        feeType: Boolean,
        default: false, // 是否禁用，默认不禁用
      },
      isJoinVip: {
        // 添加是否参与会员卡优惠的属性
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        otherTime: '', // 剩余时间类别值
        isAddTime: 1, // 是否可以增加时间区间 0置灰  1可点击 2隐藏
        IS_1TO4: /^\d{0,1}(\.\d{0,4})?$/, // 小数数字类  默认:小数点前1位、后4位
        configSet: { label: 'label', value: 'value' },
        feeTypeNames: ['尖', '峰', '平', '谷'],
        timeList: [
          {
            startValue: '', // 开始时间值
            endValue: '', // 结束时间值
            feeTypeName: '', // 选择的价格类型名称
            errorStart: '', // 校验提示-开始时间
            errorEnd: '', // 校验提示-结束时间
            errorName: '', // 校验提示-价格类型
          },
        ],
        feeList: [
          {
            name: '尖', // 价格类别名称
            feeType: '',
            powerRate: '', // 电价
            serviceRate: '', // 基础服务费
            activityServiceRate: '', // 平台活动服务费
            vipServiceRate: '', // 会员卡服务费
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            errorServicePrice: '', // 校验提示
            errorVipServicePrice: '', // 会员卡服务费校验提示
            label: '尖', // 选择时间区间时，显示的价格类别名称
            value: '尖', // 选择时间区间时，显示的价格类别值
            isDel: false, // 是否可以删除
          },
          {
            name: '峰', // 价格类别名称
            powerRate: '', // 电价
            serviceRate: '', // 基础服务费
            activityServiceRate: '', // 平台活动服务费
            vipServiceRate: '', // 会员卡服务费
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            errorServicePrice: '', // 校验提示
            errorVipServicePrice: '', // 会员卡服务费校验提示
            label: '峰', // 选择时间区间时，显示的价格类别名称
            value: '峰', // 选择时间区间时，显示的价格类别值
          },
          {
            name: '平', // 价格类别名称
            powerRate: '', // 电价
            serviceRate: '', // 基础服务费
            activityServiceRate: '', // 平台活动服务费
            vipServiceRate: '', // 会员卡服务费
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            errorServicePrice: '', // 校验提示
            errorVipServicePrice: '', // 会员卡服务费校验提示
            label: '平', // 选择时间区间时，显示的价格类别名称
            value: '平', // 选择时间区间时，显示的价格类别值
          },
          {
            name: '谷', // 价格类别名称
            powerRate: '', // 电价
            serviceRate: '', // 基础服务费
            activityServiceRate: '——', // 平台活动服务费
            vipServiceRate: '', // 会员卡服务费
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            errorServicePrice: '', // 校验提示
            errorVipServicePrice: '', // 会员卡服务费校验提示
            label: '谷', // 选择时间区间时，显示的价格类别名称
            value: '谷', // 选择时间区间时，显示的价格类别值
          },
        ],
        endTimeList: [], // 结束时间集合
        startTimeList: [], // 开始时间集合

        // 抽成费用相关字段
        isCharge: false, // 是否收取抽成
        electricityCharge: 0.1, // 电费抽成
        serviceCharge: 10, // 服务费抽成
        minChargeAmount: 2000, // 抽成保底金额
        rent: null, // 租金
        electricityFloatRate: 10, // 电费上浮比例
        channelShareRate: 10, // 渠道分成比例
        otherContractItems: '', // 其他合同费项
        bottomServiceFee: 0.4, // 电站兜底服务费
      };
    },
    watch: {
      priceData: {
        handler() {
          this.setData();
        },
        deep: true,
        immediate: true,
      },
      priceDisabled(val) {
        this.priceDisabled = val;
      },
    },
    computed: {
      // 控制会员卡服务费是否隐藏
      isVipServiceRateHidden() {
        // 当不参与会员卡优惠时隐藏会员卡服务费
        return !this.isJoinVip;
      },
      // 动态计算feeList，根据isJoinVip决定是否包含会员卡服务费相关的字段
      dynamicFeeList() {
        // 如果参与会员卡优惠，返回完整的feeList
        if (this.isJoinVip) {
          return this.feeList;
        }

        // 如果不参与会员卡优惠，过滤掉与会员卡服务费相关的字段
        return this.feeList.map(item => {
          const filteredItem = { ...item };
          // 删除会员卡服务费相关字段
          delete filteredItem.vipServiceRate;
          delete filteredItem.errorVipServicePrice;
          return filteredItem;
        });
      },
    },
    mounted() {
      this.startTimeList = this.timeInit(1);
      this.endTimeList = this.timeInit(0);
      console.log('dddd', this.priceDisabled);

      // 编辑时回填数据
      // this.setData()
    },

    methods: {
      init() {
        this.timeList = [
          {
            startValue: '', // 开始时间值
            endValue: '', // 结束时间值
            feeTypeName: '', // 选择的价格类型名称
            errorStart: '', // 校验提示-开始时间
            errorEnd: '', // 校验提示-结束时间
            errorName: '', // 校验提示-价格类型
          },
        ];
        this.isAddTime = 1;
      },
      /**
       * 回填数据
       */
      setData() {
        if (this.priceData) {
          this.init();
          const feeType = this.priceData.feeList || [];
          const time = this.priceData.priceList || [];
          if (feeType.length === 1) {
            // 只有一个价格类别
            this.setFeeList(feeType, 0);
          } else {
            // 多个价格类别
            // 回填价格类别
            for (let i = 0; i < feeType.length; i++) {
              this.setFeeList(feeType, i);
            }
            // 回填时间区间
            if (time.length === 1) {
              // 只有一个时间区间
              this.setTimeList(time, 0, 0);
              this.isAddTime = 2;
            } else {
              this.isAddTime = 1;
              let j = 0;
              for (let i = 0; i < time.length; i++) {
                if (time[i].pricePeriod !== '其余时段') {
                  // 非剩余价格
                  if (j !== 0) {
                    this.addTimeList();
                  }
                  this.setTimeList(time, i, j);
                  j++;
                } else {
                  // 剩余价格
                  this.otherTime = this.feeList[time[i].feeType - 1].name;
                  this.isAddTime = 1;
                }
              }
            }
          }
        }
      },
      /**
       * 给价格类别项赋值
       */
      setFeeList(item, index) {
        // this.feeList[index].name = item[index].pricefeeTypeName
        Object.assign(this.feeList[index], {
          name: this.feeTypeNames[index],
          powerRate: item[index].powerRate ? item[index].powerRate : 0,
          serviceRate: item[index].serviceRate ? item[index].serviceRate : 0, // 基础服务费
          activityServiceRate: item[index].activityServiceRate
            ? item[index].activityServiceRate
            : '——', // 平台活动服务费
          vipServiceRate: item[index].vipServiceRate ? item[index].vipServiceRate : '',
          label: this.isJoinVip
            ? `${this.feeList[index].name}：电费【${item[index].powerRate}元】服务费【${
                item[index].serviceRate
              }元】平台活动服务费【${
                item[index].activityServiceRate ? item[index].activityServiceRate : '——'
              }元】会员卡服务费【${
                item[index].vipServiceRate ? item[index].vipServiceRate : '——'
              }元】`
            : `${this.feeList[index].name}：电费【${item[index].powerRate}元】服务费【${
                item[index].serviceRate
              }元】平台活动服务费【${
                item[index].activityServiceRate ? item[index].activityServiceRate : '——'
              }元】`,
        });
      },
      /**
       * 增加时间区间
       */
      addTimeList() {
        const obj = {
          startValue: '', // 开始时间值
          endValue: '', // 结束时间值
          feeTypeName: '', // 选择的价格类型名称
          errorStart: '', // 校验提示-开始时间
          errorEnd: '', // 校验提示-结束时间
          errorName: '', // 校验提示-价格类型
        };
        this.timeList.push(obj);
      },
      /**
       * 给时间区间项赋值
       */
      setTimeList(item, index, key) {
        this.timeList[key].startValue = String(item[index].pricePeriod.split('~')[0]);
        this.timeList[key].endValue = String(item[index].pricePeriod.split('~')[1]);
        this.timeList[key].feeTypeName = this.feeList[item[index].feeType - 1].name;
      },
      /**
       * 初始化时间格式 48个时段
       */
      timeInit(feeType) {
        const timeBlock = [];
        for (let i = 0; i < 49; i++) {
          let a = 1;
          let b = 0;
          let label = '';
          let value = 0;
          let temp = {};
          a = Math.floor(i / 2);
          a = a > 9 ? a.toString() : `0${a}`;
          b = (i % 2) * 30;
          b = b === 30 ? b.toString() : `${b}0`;

          label = `${a}:${b}`;
          value = i;

          if (feeType === 0) {
            temp = {
              label,
              value: value + 1,
              disabled: i === 0,
            };
          } else {
            temp = {
              label,
              value: value + 1,
              disabled: i === 48,
            };
          }
          timeBlock[i.toString()] = temp;
        }
        return timeBlock;
      },
      /**
       * 校验价格类别
       */
      verifyfeeType(name, verify, msgNull, msgVerify) {
        if (!name) {
          return msgNull;
        }
        if (!verify.test(name)) {
          return msgVerify;
        }
        return '';
      },
      /**
       * 校验价格类别是否有相同
       */
      verifyfeeTypeEqual(name, index) {
        let flag = true;
        for (let i = 0; i < this.feeList.length; i++) {
          const item = this.feeList[i];
          if (index !== i && item.name === name) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      /**
       * 校验价格类型
       */
      verifyfeeTypes(feeType, index, item) {
        if (item) {
          // 失去焦点时校验
          if (feeType === 1) {
            // 校验电价
            item.errorPrice = this.verifyfeeType(
              item.powerRate,
              this.IS_1TO4,
              '请输入电费',
              '请输入正确的电费（范围：0.0000~9.9999）'
            );
            if (item.powerRate && !item.errorPrice) {
              item.powerRate = toFixed(item.powerRate, 4);
            }
          } else if (feeType === 2) {
            // 校验服务费
            item.errorServicePrice = this.verifyfeeType(
              item.serviceRate,
              this.IS_1TO4,
              '请输入服务费',
              '请输入正确的服务费（范围：0.0000~9.9999）'
            );
            if (item.serviceRate && !item.errorServicePrice) {
              item.serviceRate = toFixed(item.serviceRate, 4);
            }

            // 校验会员卡服务费
            const memberCardError = this.verifyfeeType(
              item.vipServiceRate,
              this.IS_1TO4,
              '请输入会员卡服务费',
              '请输入正确的会员卡服务费（范围：0.0000~9.9999）'
            );
            item.errorVipServicePrice = memberCardError; // 为会员卡服务费单独设置错误信息字段
            if (item.vipServiceRate && !memberCardError) {
              item.vipServiceRate = toFixed(item.vipServiceRate, 4);
            }
          }
          if (!item.errorName) {
            item.value = item.name;
          }
          item.label = this.isJoinVip
            ? `${item.name}：电费【${item.powerRate}元】服务费【${item.serviceRate}元】平台活动服务费【${item.activityServiceRate}元】会员卡服务费【${item.vipServiceRate}元】`
            : `${item.name}：电费【${item.powerRate}元】服务费【${item.serviceRate}元】平台活动服务费【${item.activityServiceRate}元】`;
          this.$set(this.feeList, index, item);
        } else {
          // 全部校验
          for (let i = this.feeList.length - 1; i >= 0; i--) {
            const items = this.feeList[i];
            items.errorPrice = this.verifyfeeType(
              items.powerRate,
              this.IS_1TO4,
              '请输入电费',
              '请输入正确的电费（范围：0.0000~9.9999）'
            );
            items.errorServicePrice = this.verifyfeeType(
              items.serviceRate,
              this.IS_1TO4,
              '请输入服务费',
              '请输入正确的服务费（范围：0.0000~9.9999）'
            );

            // 校验会员卡服务费
            if (this.isJoinVip) {
              items.errorVipServicePrice = this.verifyfeeType(
                items.vipServiceRate,
                this.IS_1TO4,
                '请输入会员卡服务费',
                '请输入正确的会员卡服务费（范围：0.0000~9.9999）'
              );
            }
          }
        }
      },
      /**
       * 判断价格类型是否校验通过
       */
      isfeeType() {
        let flag = true;
        for (let i = this.feeList.length - 1; i >= 0; i--) {
          const item = this.feeList[i];
          if (
            !item.name ||
            !item.powerRate ||
            !item.serviceRate ||
            !item.vipServiceRate ||
            item.errorName ||
            item.errorPrice ||
            item.errorServicePrice ||
            item.errorVipServicePrice
          ) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      /**
       * 开始下拉选择时间区间
       */
      selectFocusTime(feeType, index, item) {
        if (feeType === 1) {
          // 选择开始时间
          for (let i = 0; i < 48; i++) {
            this.startTimeList[i].disabled = false;
          }
          if (item.endValue) {
            // 当前区间有结束时间时，结束时间之后的开始时间选项置灰
            for (let i = item.endValue - 1; i < 48; i++) {
              this.startTimeList[i].disabled = true;
            }
          }
          for (let i = 0; i < this.timeList.length; i++) {
            const tmp = this.timeList[i];
            if (i !== index) {
              // 非当前时间区间
              if (item.endValue && item.endValue > tmp.endValue) {
                // 如有当前结束时间且当前结束时间>已选结束时间，已选结束时间之前置灰
                for (let j = 0; j < tmp.endValue - 1; j++) {
                  this.startTimeList[j].disabled = true;
                }
              } else {
                // 将已选时间区间的时间选项置灰
                for (let j = tmp.startValue - 1; j < tmp.endValue - 1; j++) {
                  this.startTimeList[j].disabled = true;
                }
              }
            }
          }
        } else {
          // 选择结束时间
          for (let i = 1; i < 49; i++) {
            this.endTimeList[i].disabled = false;
          }
          if (item.startValue) {
            // 当前区间有开始时间时，开始时间之前的开始时间选项置灰
            for (let i = 1; i < item.startValue; i++) {
              this.endTimeList[i].disabled = true;
            }
          }
          for (let i = 0; i < this.timeList.length; i++) {
            const tmp = this.timeList[i];
            if (i !== index) {
              // 非当前时间区间
              if (item.startValue && item.startValue < tmp.startValue) {
                // 如果当前开始时间且当前开始时间<已选当前时间，已选当前时间之后的选项置灰
                for (let j = tmp.startValue; j < 49; j++) {
                  this.endTimeList[j].disabled = true;
                }
              } else {
                // 将已选时间区间的时间选项置灰
                for (let j = tmp.startValue; j < tmp.endValue; j++) {
                  this.endTimeList[j].disabled = true;
                }
              }
            }
          }
        }
      },
      /**
       * 选项时间区间和类别时事件-校验
       */
      selectChange(evt, feeType) {
        if (feeType < 4) {
          // 非剩余时段进行校验
          this.verifyTime();
        }
      },
      /**
       * 校验时间区间
       */
      verifyTime(isMsg) {
        let flag = true;
        for (let i = 0; i < this.timeList.length; i++) {
          const item = this.timeList[i];
          if (item.startValue) {
            item.errorStart = '';
          } else if (!item.startValue) {
            flag = false;
            if (isMsg) {
              item.errorStart = '请选择开始时间';
            } else {
              break;
            }
          }
          if (item.endValue) {
            item.errorEnd = '';
          } else if (!item.endValue) {
            flag = false;
            if (isMsg) {
              item.errorEnd = '请选择结束时间';
            } else {
              break;
            }
          }
          if (item.feeTypeName) {
            item.errorName = '';
          } else if (!item.feeTypeName) {
            flag = false;
            if (isMsg) {
              item.errorName = '请选择价格类型';
            } else {
              break;
            }
          }
        }

        const arr = [];
        for (let i = 0; i < this.timeList.length; i++) {
          const item = this.timeList[i];
          for (let j = item.startValue; j < item.endValue; j++) {
            arr.push(j);
          }
        }
        if (arr.length === 48) {
          this.isAddTime = 2;
        } else {
          this.isAddTime = 0;
          if (!this.otherTime) {
            this.otherTime = this.feeList[0].name;
          }
        }

        if (this.isAddTime !== 2) {
          this.isAddTime = flag ? 1 : 0;
        }
      },
      /**
       * 判断时间区间是否校验通过
       */
      isTime() {
        let flag = true;
        if (this.feeList.length > 1) {
          for (let i = this.timeList.length - 1; i >= 0; i--) {
            const item = this.timeList[i];
            if (
              !item.startValue ||
              !item.endValue ||
              !item.feeTypeName ||
              item.errorStart ||
              item.errorEnd ||
              item.errorName
            ) {
              flag = false;
              break;
            }
          }
        }

        return flag;
      },
      /**
       * 添加时间区间
       */
      clickAddTime() {
        this.verifyTime(true);
        if (this.isAddTime === 1) {
          this.addTimeList();
          this.isAddTime = 0;
        }
      },
      /**
       * 删除时间区间
       */
      clickTimeDel(evt, index, item) {
        if (this.priceDisabled) {
          // 禁用不能操作
          return;
        }
        if (index === 0 && item.startValue === 1 && item.endValue === 49) {
          return;
        }
        if (this.timeList.length > 1) {
          // 删除价格类型
          this.timeList.splice(index, 1);
        }
        if (this.isAddTime !== 1) {
          // 时间区间  显示增加按钮
          this.isAddTime = 1;
        }
        // 判断未选中的价格类别可以删除
        if (this._) {
          this._.find(this.feeList, { name: item.feeTypeName }).isDel = true;
        }
      },
      /**
       *
       */
      saveVerifyOMP() {
        this.verifyfeeTypes();
        this.verifyTime(true);
        let obj = null;

        if (this.isfeeType() && this.isTime()) {
          obj = {};
          obj.feeList = []; // 价格组集合
          this.feeList.forEach((item, index) => {
            obj.feeList.push({
              feeType: index + 1, // 下标
              pricefeeTypeName: item.name, // 类别名称
              powerRate: Number(item.powerRate ? item.powerRate : 0), // 电费
              serviceRate: Number(item.serviceRate ? item.serviceRate : 0), // 基础服务费
              activityServiceRate: Number(
                item.activityServiceRate ? item.activityServiceRate : '——'
              ), // 平台活动服务费
              vipServiceRate: Number(item.vipServiceRate ? item.vipServiceRate : 0), // 会员卡服务费
              stationFeeId: '',
            });
          });

          obj.priceList = []; // 充电费用集合

          if (this.feeList.length > 1) {
            this.timeList.forEach(item => {
              this.feeList.forEach((item1, index1) => {
                if (item.feeTypeName === item1.name) {
                  obj.priceList.push({
                    defaultFlag: '0', // 是否剩余 0非剩余  1剩余
                    priceStartPeriod: item.startValue, // 开始时间
                    priceEndPeriod: item.endValue, // 结束时间
                    feeType: index1 + 1, // 类别下标
                    powerRate: Number(item1.powerRate ? item1.powerRate : 0), // 电费
                    serviceRate: Number(item1.serviceRate ? item1.serviceRate : 0), // 基础服务费
                    activityServiceRate: Number(
                      item1.activityServiceRate ? item1.activityServiceRate : '——'
                    ), // 平台活动服务费
                    vipServiceRate: Number(item1.vipServiceRate ? item1.vipServiceRate : 0), // 会员卡服务费
                    stationPriceId: '',
                  });
                }
              });
            });

            if (this.isAddTime !== 2) {
              this.feeList.forEach((item, index) => {
                if (this.otherTime === item.name) {
                  obj.priceList.push({
                    defaultFlag: '1', // 是否剩余 0非剩余  1剩余
                    priceStartPeriod: 0, // 开始时间
                    priceEndPeriod: 0, // 结束时间
                    feeType: index + 1, // 类别下标
                    powerRate: Number(item.powerRate ? item.powerRate : 0), // 电费
                    serviceRate: Number(item.serviceRate ? item.serviceRate : 0), // 基础服务费
                    activityServiceRate: Number(
                      item.activityServiceRate ? item.activityServiceRate : '——'
                    ), // 平台活动服务费
                    vipServiceRate: item.vipServiceRate ? Number(item.vipServiceRate) : '', // 会员卡服务费
                    stationPriceId: '',
                  });
                }
              });
            }
          } else {
            obj.priceList.push({
              defaultFlag: '0', // 是否剩余 0非剩余  1剩余
              priceStartPeriod: 1, // 开始时间
              priceEndPeriod: 49, // 结束时间
              feeType: 1, // 类别下标
              powerRate: Number(this.feeList[0].powerRate ? this.feeList[0].powerRate : 0), // 电费
              serviceRate: Number(this.feeList[0].serviceRate ? this.feeList[0].serviceRate : 0), // 基础服务费
              activityServiceRate: Number(
                this.feeList[0].activityServiceRate ? this.feeList[0].activityServiceRate : '——'
              ), // 平台活动服务费
              vipServiceRate: this.feeList[0].vipServiceRate
                ? Number(this.feeList[0].vipServiceRate)
                : '', // 会员卡服务费
              stationPriceId: '',
            });
          }
        }
        console.log(obj);
        return obj;
      },
    },
  };
</script>

<style lang="scss">
  .price-display {
    .configCategory {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .ykc-icon-reduce {
        height: 16px;
        margin-top: 7px;
        margin-right: 8px;
        cursor: pointer;
        text-align: right;
        color: var(--theme-color-primary);

        &.disabled {
          color: #d7d7d7;
          cursor: not-allowed;
        }
      }

      .configCategory-input {
        width: 120px;
      }

      .box-width-right {
        margin: 0 8px;
      }

      .box-width-left {
        margin-left: 8px;
      }

      .box-width {
        flex: 1;
      }

      // 新增类型下拉框样式
      .feeType-dropdown {
        width: 590px;
        margin-left: 8px;
      }
    }

    .pointer {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;

      .ykc-icon-add {
        height: 16px;
        margin-top: 1px;
        margin-right: 8px;
        cursor: pointer;
        text-align: right;
        font-size: 15px;
        color: var(--theme-color-primary);

        &.disabled {
          color: #d7d7d7;
          cursor: not-allowed;
        }
      }

      .bnt-text {
        cursor: pointer;
        font-size: 14px;
        color: var(--theme-color-primary);
      }
    }

    .time-line {
      margin: 0 6.5px;
    }

    .time-width {
      width: 378px;
    }
  }
</style>
